import PageviewTracker from './PageviewTracker';
import {
  EventAction,
  EventCategory,
  trackEvent,
  trackSaveImage,
  trackCopyLink,
  trackShare,
  trackVoteClick,
  trackWebVitals,
} from './utils';

export default PageviewTracker;

export {
  EventAction,
  EventCategory,
  trackEvent,
  trackSaveImage,
  trackCopyLink,
  trackShare,
  trackVoteClick,
  trackWebVitals,
};
